/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaymentMethodsWallet,
  PaymentMethodsWallet$inboundSchema,
  PaymentMethodsWallet$Outbound,
  PaymentMethodsWallet$outboundSchema,
} from "./paymentmethodswallet.js";

export type MoovWalletPaymentMethod = {
  /**
   * ID of the payment method.
   */
  paymentMethodID: string;
  paymentMethodType: "moov-wallet";
  wallet: PaymentMethodsWallet;
};

/** @internal */
export const MoovWalletPaymentMethod$inboundSchema: z.ZodType<
  MoovWalletPaymentMethod,
  z.ZodTypeDef,
  unknown
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("moov-wallet"),
  wallet: PaymentMethodsWallet$inboundSchema,
});
/** @internal */
export type MoovWalletPaymentMethod$Outbound = {
  paymentMethodID: string;
  paymentMethodType: "moov-wallet";
  wallet: PaymentMethodsWallet$Outbound;
};

/** @internal */
export const MoovWalletPaymentMethod$outboundSchema: z.ZodType<
  MoovWalletPaymentMethod$Outbound,
  z.ZodTypeDef,
  MoovWalletPaymentMethod
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("moov-wallet"),
  wallet: PaymentMethodsWallet$outboundSchema,
});

export function moovWalletPaymentMethodToJSON(
  moovWalletPaymentMethod: MoovWalletPaymentMethod,
): string {
  return JSON.stringify(
    MoovWalletPaymentMethod$outboundSchema.parse(moovWalletPaymentMethod),
  );
}
export function moovWalletPaymentMethodFromJSON(
  jsonString: string,
): SafeParseResult<MoovWalletPaymentMethod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MoovWalletPaymentMethod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MoovWalletPaymentMethod' from JSON`,
  );
}
